import type { SupWeb3Balance } from "@/hooks/api/useTokenBalances";
import React, { Dispatch, SetStateAction, useEffect } from "react";

import { SupCheckbox, SupTooltip } from "@repo/core-ui";

interface Web3DepositApprovalSwitchPermit2Props {
  usePermit2: boolean;
  setUsePermit2: Dispatch<SetStateAction<boolean>>;
  selectedBalance: SupWeb3Balance;
}

export default function Web3DepositApprovalSwitchPermit2({ selectedBalance, usePermit2, setUsePermit2 }: Web3DepositApprovalSwitchPermit2Props) {
  useEffect(() => {
    if (selectedBalance.chainId === 43114) {
      setUsePermit2(false);
    }
  }, [selectedBalance, setUsePermit2]);

  return (
    selectedBalance.chainId !== 43114 && (
      <div className="flex w-full items-center justify-end">
        <SupTooltip unmount portal color="primary" placement="top-end" content="Permit2 enables approvals only with a signature">
          <div>
            <SupCheckbox label="Use Permit2 Approval" orientation="right" name="switcher" checked={usePermit2} onChange={() => setUsePermit2(!usePermit2)} />
          </div>
        </SupTooltip>
      </div>
    )
  );
}
